import { FC } from 'react';
import { Skeleton } from '@components/atoms/Skeleton';
import { ActivityCardSkeleton } from '@components/molecules/ActivityCardSkeleton';
import { cn } from '@utils/cn';

interface FeedSkeletonListProps {
  count?: number;
  className?: string;
}

/**
 * Loading placeholder for the activity feed: a date-group header plus a column
 * of ActivityCardSkeleton rows, matching the real ProjectFeed layout. Used for
 * the initial load of the dashboard / projects / subcontractor feeds.
 */
export const FeedSkeletonList: FC<FeedSkeletonListProps> = ({ count = 6, className }) => (
  <div
    className={cn('relative flex flex-col gap-4 w-full max-w-3xl mx-auto', className)}
    aria-hidden="true"
    data-testid="feed-skeleton"
  >
    <div className="flex items-center gap-3 py-2">
      <Skeleton height={12} width={96} />
      <div className="flex-1 h-px bg-gray-200 dark:bg-gray-700" />
    </div>
    <div className="flex flex-col gap-4">
      {Array.from({ length: count }).map((_, index) => (
        <ActivityCardSkeleton key={index} />
      ))}
    </div>
  </div>
);

export default FeedSkeletonList;
